import {
  DEFAULT_PAGE_SIZE_OPTIONS,
  type TablePreferencesConfig,
} from 'src/common/ui/TablePreferences';

import { TRACK_PAGE_SIZE } from '../constants';
import type { TranslateFn } from 'src/i18n/shim/useTranslation';

/**
 * Configs for the two Track tables; ids and order mirror `columns.tsx`. Separate
 * keys because the column sets only partly overlap. Nothing is pinned last —
 * Track has no CSS-pinned actions column.
 */

const PAGE_SIZE = {
  pageSizeOptions: DEFAULT_PAGE_SIZE_OPTIONS,
  defaultPageSize: TRACK_PAGE_SIZE,
} as const;

/**
 * Namespace starts hidden: reaching either table means filtering by namespace
 * first, so it repeats one value per row. Still in the gear, returning last.
 */
const DEFAULT_HIDDEN = {
  defaultHiddenColumnIds: ['namespace'],
} as const;

export const activeJobsPreferences = (
  t: TranslateFn,
): TablePreferencesConfig => ({
  storageKey: 'LangHub-trackTablePreferences-ACTIVE',
  columnOptions: [
    { id: 'stringGroup', label: t('track-column-string-group') },
    { id: 'version', label: t('track-column-version') },
    { id: 'dueDate', label: t('track-column-due-date') },
    { id: 'sentForTranslation', label: t('track-column-sent-on') },
    { id: 'status', label: t('track-column-status') },
    { id: 'trackingId', label: t('track-column-trace-id') },
    { id: 'clientId', label: t('track-column-ingestion-source') },
    { id: 'namespace', label: t('track-column-namespace') },
  ],
  ...PAGE_SIZE,
  ...DEFAULT_HIDDEN,
});

export const historicalJobsPreferences = (
  t: TranslateFn,
): TablePreferencesConfig => ({
  storageKey: 'LangHub-trackTablePreferences-HISTORICAL',
  columnOptions: [
    { id: 'stringGroup', label: t('track-column-string-group') },
    { id: 'version', label: t('track-column-version') },
    { id: 'deliveredOn', label: t('track-column-delivered-on') },
    { id: 'sentOn', label: t('track-column-sent-on') },
    { id: 'turnaround', label: t('track-column-tat') },
    { id: 'status', label: t('track-column-status') },
    { id: 'trackingId', label: t('track-column-trace-id') },
    { id: 'clientId', label: t('track-column-ingestion-source') },
    { id: 'namespace', label: t('track-column-namespace') },
  ],
  ...PAGE_SIZE,
  ...DEFAULT_HIDDEN,
});
